import routes from "common/routes";
import { IRoute } from "utils/routes";
import {
  EPreRacesTableTab,
  EPreRaceTableSortingField,
  IPreRaceTableTab
} from "./types";

import { racehorse360 } from "@tsg/1st-grpc-web-rh360";

export const INFINITE_LIST_UPCOMING_RACE_ENTRIES_QUERY_KEY =
  "infinite-list-upcoming-race-entries" as const;
export const PRE_RACE_ENTRIES_TOTAL_RESULTS_QUERY_KEY =
  "pre-race-entries-total-result-query-key" as const;

export const preRacesTableTabs: IPreRaceTableTab[] = [
  {
    name: EPreRacesTableTab.ENTRIES,
    value: EPreRacesTableTab.ENTRIES,
    path: routes.preRaceScreeningEntries.path,
    entryStatuses: [
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED
    ],
    itemsPerPage: 15,
    additionalRequestedFields: [
      "horse.hasActualFlagOnTrack",
      "horse.flagOnTrack.flagOnTrackComment",
      "horse.riskFactorShortDescriptions",
      "horse.riskFactorScore",
      "horse.riskFactorsCount",
      "horse.totalVetListsCount",
      "horse.activeVetListsCount",
      "horse.lastFivePastPerformances",
      "horse.lastExamDate",
      "horse.lastExamResult",
      "horse.lifetime.starts",
      "horse.lifetime.wins",
      "horse.lifetime.place",
      "horse.lifetime.show",
      "horse.lastExamNote.note",
      "horse.lastExamNote.createdOn",
      "horse.lastExamNote.createdBy.firstName",
      "horse.lastExamNote.createdBy.lastName",
      "flag.priority",
      "flag.flaggedBy.lastName",
      "flag.flaggedOn",
      "entryExamNote.body",
      "entryExamNote.notedBy",
      "entryExamNote.notedOn"
    ]
  },
  {
    name: EPreRacesTableTab.ENTRY_EXAMS,
    value: EPreRacesTableTab.ENTRY_EXAMS,
    path: routes.preRaceScreeningEntryExams.path,
    entryStatuses: [
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING
    ],
    itemsPerPage: 20,
    additionalRequestedFields: [
      "horse.riskFactorShortDescriptions",
      "horse.riskFactorScore",
      "horse.riskFactorsCount",
      "horse.totalVetListsCount",
      "horse.activeVetListsCount",
      "horse.lastExamDate",
      "horse.lastExamResult",
      "entryExamNote.body",
      "entryExamNote.notedBy",
      "entryExamNote.notedOn",
      "facility.id",
      "flag.priority",
      "flag.flaggedBy.lastName",
      "flag.flaggedOn",
      "entryExam.id",
      "entryExam.status",
      "entryExam.assignedUser.id",
      "entryExam.assignedUser.firstName",
      "entryExam.assignedUser.lastName"
    ],
    forceOrderBy: EPreRaceTableSortingField.TRAINER_LAST_NAME
  },
  {
    name: EPreRacesTableTab.ENTRY_RESULTS,
    value: EPreRacesTableTab.ENTRY_RESULTS,
    path: routes.preRaceScreeningResults.path,
    entryStatuses: [
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED
    ],
    itemsPerPage: 20,
    additionalRequestedFields: ["entryExam.result", "entryExam.type"]
  },
  {
    name: EPreRacesTableTab.RACE_DAY,
    value: EPreRacesTableTab.RACE_DAY,
    path: routes.preRaceScreeningRaceDay.path,
    entryStatuses: [
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_ENTRY_SUBMITTED,
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_PENDING,
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_ENTRY_EXAM_COMPLETED,
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_PENDING
    ],
    itemsPerPage: 20,
    additionalRequestedFields: [
      "horse.riskFactorShortDescriptions",
      "horse.riskFactorsCount",
      "horse.riskFactorScore",
      "horse.totalVetListsCount",
      "horse.activeVetListsCount",
      "horse.lastExamDate",
      "horse.lastExamResult",
      "entryExamNote.body",
      "entryExamNote.notedBy",
      "entryExamNote.notedOn",
      "facility.id",
      "raceDayExam.id",
      "raceDayExam.status",
      "raceDayExam.assignedUser.id",
      "raceDayExam.assignedUser.firstName",
      "raceDayExam.assignedUser.lastName",
      "flag.priority",
      "flag.flaggedBy.lastName",
      "flag.flaggedOn",
      "entryExam.result",
      "entryExam.type"
    ],
    forceOrderBy: EPreRaceTableSortingField.TRAINER_LAST_NAME
  },
  {
    name: EPreRacesTableTab.RACE_DAY_RESULTS,
    value: EPreRacesTableTab.RACE_DAY_RESULTS,
    path: routes.preRaceScreeningRaceDayResults.path,
    entryStatuses: [
      racehorse360.UpcomingRaceEntryStatus
        .UPCOMING_RACE_ENTRY_STATUS_RACE_DAY_EXAM_COMPLETED
    ],
    itemsPerPage: 20,
    additionalRequestedFields: [
      "horse.riskFactorShortDescriptions",
      "horse.riskFactorsCount",
      "horse.riskFactorScore",
      "horse.totalVetListsCount",
      "horse.activeVetListsCount",
      "horse.lastExamNote.note",
      "horse.lastExamNote.createdOn",
      "horse.lastExamNote.createdBy.firstName",
      "horse.lastExamNote.createdBy.lastName",
      "raceDayExam.result",
      "raceDayExam.type",
      "raceDayExam.conclusion.description",
      "raceDayExam.updatedBy.firstName",
      "raceDayExam.updatedBy.lastName",
      "raceDayExam.completedOn"
    ],
    forceOrderBy: EPreRaceTableSortingField.RACE_NUMBER
  }
];

export const possiblePreRaceScreeningRoutes: IRoute[] = [
  routes.preRaceScreeningEntries,
  routes.preRaceScreeningEntryExams,
  routes.preRaceScreeningResults,
  routes.preRaceScreeningRaceDay,
  routes.preRaceScreeningRaceDayResults
];

export const commonRequestedFields: string[] = [
  "raceDate",
  "raceNumber",
  "racePosition",
  "highSpeedFurlongs",
  "claimChange",
  "classChange",
  "horse.name",
  "horse.barn.name",
  "horse.birthday",
  "horse.gender",
  "horse.color",
  "horse.healthWatchStatus",
  "horse.lastWorkoutDate",
  "horse.lastRaceDate",
  "horse.stallNumber",
  "horse.trainer.firstName",
  "horse.trainer.middleName",
  "horse.trainer.lastName",
  "horse.currentFacility.id",
  "horse.currentFacility.code",
  "facility.timezone",
  "upcomingRace.raceType",
  "upcomingRace.courseType",
  "upcomingRace.distance",
  "upcomingRace.distanceUnit",
  "upcomingRace.raceConditions",
  "upcomingRace.maximumClaimPrice",
  "upcomingRace.restrictionType"
];
